import ProgressBar from "@components/scheduling/analytics/ProgressBar";
import { CAMPAIGN_STATUS, formatWireTime } from "@components/scheduling/campaignLabels";

const INPUT = "rounded-lg border border-gray-300 bg-white px-2 py-1.5 text-sm text-gray-900 "
  + "focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500";

/**
 * Which campaign and which days the numbers cover. The date inputs show the
 * server's period until the user picks a day, so the range on screen is
 * always the range the figures were computed for. The progress bar under
 * the row is the only sign of a quiet reload.
 */
export default function AnalyticsFilters({
  campaigns = [], filters = {}, onChange, period, startedAt, refreshing = false,
}) {
  const from = filters.from ?? period?.from ?? "";
  const to = filters.to ?? period?.to ?? "";
  return (
    <div>
      <div className="flex flex-wrap items-end gap-3">
        <label className="flex flex-col gap-1 text-xs font-medium text-gray-600">
          Campaign
          <select
            aria-label="Campaign"
            className={`${INPUT} min-w-[14rem]`}
            value={filters.campaignId ?? ""}
            onChange={(e) => onChange({ campaignId: e.target.value || null })}
          >
            <option value="">All campaigns</option>
            {campaigns.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name} · {CAMPAIGN_STATUS[c.status]?.label || c.status}
              </option>
            ))}
          </select>
        </label>
        <label className="flex flex-col gap-1 text-xs font-medium text-gray-600">
          From
          <input type="date" aria-label="From" className={INPUT} value={from}
                 max={to || undefined}
                 onChange={(e) => onChange({ from: e.target.value || null })} />
        </label>
        <label className="flex flex-col gap-1 text-xs font-medium text-gray-600">
          To
          <input type="date" aria-label="To" className={INPUT} value={to}
                 min={from || undefined}
                 onChange={(e) => onChange({ to: e.target.value || null })} />
        </label>
        {startedAt && (
          <p className="pb-2 text-xs text-gray-500">Since {formatWireTime(startedAt)}</p>
        )}
      </div>
      <div className="mt-2 h-0.5">
        <ProgressBar active={refreshing} />
      </div>
    </div>
  );
}
